<main class="cash-flow-page">
  <header class="page-header">
    <div>
      <span class="eyebrow">FINANCEIRO</span>
      <h1>Fluxo de caixa</h1>
      <p>Acompanhe as entradas, saídas e o saldo do restaurante.</p>
    </div>

    <div class="header-actions">
      <button class="button secondary" (click)="openCreateModal('INCOME')">
        + Nova entrada
      </button>
      <button class="button primary" (click)="openCreateModal('EXPENSE')">
        + Nova saída
      </button>
    </div>
  </header>

  <section class="filters-card">
    <div class="field">
      <label for="restaurant">Restaurante</label>
      <select
        id="restaurant"
        [(ngModel)]="restaurantId"
        (change)="onRestaurantChange()"
        [disabled]="loadingRestaurants">
        <option [ngValue]="null">Selecione um restaurante</option>
        <option *ngFor="let restaurant of restaurants" [ngValue]="restaurant.id">
          {{ restaurant.name }}
        </option>
      </select>
    </div>

    <div class="period-buttons">
      <button [class.active]="selectedPeriod === 'today'" (click)="setPeriod('today')">Hoje</button>
      <button [class.active]="selectedPeriod === '7days'" (click)="setPeriod('7days')">7 dias</button>
      <button [class.active]="selectedPeriod === '30days'" (click)="setPeriod('30days')">30 dias</button>
      <button [class.active]="selectedPeriod === 'month'" (click)="setPeriod('month')">Este mês</button>
    </div>

    <div class="date-filter">
      <div class="field">
        <label for="startDate">Data inicial</label>
        <input id="startDate" type="date" [(ngModel)]="startDate">
      </div>
      <div class="field">
        <label for="endDate">Data final</label>
        <input id="endDate" type="date" [(ngModel)]="endDate">
      </div>
      <button class="button filter-button" (click)="applyCustomPeriod()">Aplicar</button>
    </div>
  </section>

  <div *ngIf="error" class="alert error-alert">{{ error }}</div>
  <div *ngIf="success" class="alert success-alert">{{ success }}</div>

  <section class="summary-grid">
    <article class="summary-card income-card">
      <div class="summary-icon">↗</div>
      <div>
        <span>Total de entradas</span>
        <strong>{{ formatMoney(summary.totalIncome) }}</strong>
        <small>Recebimentos no período</small>
      </div>
    </article>

    <article class="summary-card expense-card">
      <div class="summary-icon">↘</div>
      <div>
        <span>Total de saídas</span>
        <strong>{{ formatMoney(summary.totalExpense) }}</strong>
        <small>Despesas no período</small>
      </div>
    </article>

    <article class="summary-card balance-card" [ngClass]="getBalanceClass()">
      <div class="summary-icon">R$</div>
      <div>
        <span>Saldo</span>
        <strong>{{ formatMoney(summary.balance) }}</strong>
        <small>Entradas menos saídas</small>
      </div>
    </article>

    <article class="summary-card entries-card">
      <div class="summary-icon">≡</div>
      <div>
        <span>Lançamentos</span>
        <strong>{{ summary.entries }}</strong>
        <small>Registros no período</small>
      </div>
    </article>
  </section>

  <section class="chart-card">
    <div class="section-heading">
      <div>
        <h2>Entradas e saídas</h2>
        <p>Comparativo dos lançamentos por dia.</p>
      </div>
    </div>
    <div #cashFlowChart class="cash-flow-chart"></div>
  </section>

 <section class="table-card">
  <div class="section-heading table-heading">
    <div>
      <h2>Lançamentos</h2>

      <p>
        Histórico financeiro do período selecionado.
      </p>
    </div>

    <div class="table-actions">
      <div class="view-mode-buttons">
        <button
          type="button"
          [class.active]="viewMode === 'SUMMARY'"
          (click)="setViewMode('SUMMARY')">

          Resumido
        </button>

        <button
          type="button"
          [class.active]="viewMode === 'DETAILED'"
          (click)="setViewMode('DETAILED')">

          Detalhado
        </button>
      </div>

      <div class="field type-filter">
        <label for="typeFilter">
          Tipo
        </label>

        <select
          id="typeFilter"
          [(ngModel)]="typeFilter"
          (change)="onTypeFilterChange()">

          <option value="">
            Todos
          </option>

          <option value="INCOME">
            Entradas
          </option>

          <option value="EXPENSE">
            Saídas
          </option>
        </select>
      </div>
    </div>
  </div>

  <div
    *ngIf="loadingData"
    class="loading-state">

    Carregando fluxo de caixa...
  </div>

  <div
    *ngIf="!loadingData && !entries.length"
    class="empty-state">

    <div class="empty-icon">
      R$
    </div>

    <h3>
      Nenhum lançamento encontrado
    </h3>

    <p>
      Cadastre uma entrada ou uma saída para iniciar
      o controle financeiro.
    </p>

    <button
      class="button primary"
      (click)="openCreateModal('EXPENSE')">

      Criar lançamento
    </button>
  </div>

  <!-- MODO RESUMIDO -->

  <div
    *ngIf="
      !loadingData &&
      entries.length &&
      viewMode === 'SUMMARY'
    "
    class="table-wrapper">

    <table>
      <thead>
        <tr>
          <th>Data</th>
          <th>Descrição</th>
          <th>Categoria</th>
          <th>Origem</th>
          <th>Tipo</th>
          <th class="money-column">
            Valor
          </th>
          <th class="actions-column">
            Ações
          </th>
        </tr>
      </thead>

      <tbody>
        <ng-container
          *ngFor="
            let group of groupedEntries;
            trackBy: trackByGroupKey
          ">

          <tr>
            <td>
              {{ formatDate(group.date) }}
            </td>

            <td>
              <strong class="entry-description">
                {{ group.description }}
              </strong>

              <small *ngIf="group.source === 'ORDER'">
                {{ group.orderCount }}

                {{
                  group.orderCount === 1
                    ? 'pedido entregue'
                    : 'pedidos entregues'
                }}
              </small>
            </td>

            <td>
              {{ group.category }}
            </td>

            <td>
              <span
                class="source-badge"
                [class.order-source]="
                  group.source === 'ORDER'
                "
                [class.system-source]="
                  group.source === 'SYSTEM'
                ">

                {{ getSourceLabel(group.source) }}
              </span>
            </td>

            <td>
              <span
                class="type-badge"
                [class.income]="
                  group.type === 'INCOME'
                "
                [class.expense]="
                  group.type === 'EXPENSE'
                ">

                {{ getTypeLabel(group.type) }}
              </span>
            </td>

            <td
              class="money-column entry-value"
              [class.income-value]="
                group.type === 'INCOME'
              "
              [class.expense-value]="
                group.type === 'EXPENSE'
              ">

              {{
                group.type === 'INCOME'
                  ? '+'
                  : '-'
              }}

              {{ formatMoney(group.amount) }}
            </td>

            <td class="actions-column">
              <button
                *ngIf="group.source === 'ORDER'"
                type="button"
                class="details-button"
                (click)="toggleGroup(group)">

                {{
                  group.expanded
                    ? 'Ocultar'
                    : 'Ver pedidos'
                }}
              </button>

              <ng-container
                *ngIf="
                  group.source === 'MANUAL' &&
                  group.entries.length
                ">

                <button
                  class="icon-button"
                  title="Editar"
                  (click)="openEditModal(group.entries[0])">

                  ✎
                </button>

                <button
                  class="icon-button danger"
                  title="Excluir"
                  [disabled]="
                    deletingId === group.entries[0].id
                  "
                  (click)="deleteEntry(group.entries[0])">

                  {{
                    deletingId === group.entries[0].id
                      ? '...'
                      : '×'
                  }}
                </button>
              </ng-container>
            </td>
          </tr>

          <tr
            *ngIf="
              group.source === 'ORDER' &&
              group.expanded
            "
            class="order-details-row">

            <td colspan="7">
              <div class="order-details">
                <div class="order-details-header">
                  <strong>
                    Pedidos entregues em
                    {{ formatDate(group.date) }}
                  </strong>

                  <span>
                    Total:
                    {{ formatMoney(group.amount) }}
                  </span>
                </div>

                <div
                  *ngFor="
                    let orderEntry of group.entries;
                    trackBy: trackByEntryId
                  "
                  class="order-detail-item">

                  <div>
                    <strong>
                      Pedido #{{ orderEntry.orderId }}
                    </strong>

                    <small>
                      {{ orderEntry.description }}
                    </small>
                  </div>

                  <strong class="income-value">
                    + {{ formatMoney(orderEntry.amount) }}
                  </strong>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <!-- MODO DETALHADO -->

  <div
    *ngIf="
      !loadingData &&
      entries.length &&
      viewMode === 'DETAILED'
    "
    class="table-wrapper">

    <table>
      <thead>
        <tr>
          <th>Data</th>
          <th>Descrição</th>
          <th>Categoria</th>
          <th>Origem</th>
          <th>Tipo</th>

          <th class="money-column">
            Valor
          </th>

          <th class="actions-column">
            Ações
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="
            let entry of entries;
            trackBy: trackByEntryId
          ">

          <td>
            {{ formatDate(entry.entryDate) }}
          </td>

          <td>
            <strong class="entry-description">
              {{ entry.description }}
            </strong>

            <small *ngIf="entry.orderId">
              Pedido #{{ entry.orderId }}
            </small>
          </td>

          <td>
            {{ entry.category }}
          </td>

          <td>
            <span
              class="source-badge"
              [class.order-source]="
                entry.source === 'ORDER'
              "
              [class.system-source]="
                entry.source === 'SYSTEM'
              ">

              {{ getSourceLabel(entry.source) }}
            </span>
          </td>

          <td>
            <span
              class="type-badge"
              [class.income]="
                entry.type === 'INCOME'
              "
              [class.expense]="
                entry.type === 'EXPENSE'
              ">

              {{ getTypeLabel(entry.type) }}
            </span>
          </td>

          <td
            class="money-column entry-value"
            [class.income-value]="
              entry.type === 'INCOME'
            "
            [class.expense-value]="
              entry.type === 'EXPENSE'
            ">

            {{
              entry.type === 'INCOME'
                ? '+'
                : '-'
            }}

            {{ formatMoney(entry.amount) }}
          </td>

          <td class="actions-column">
            <button
              class="icon-button"
              title="Editar"
              [disabled]="
                entry.source !== 'MANUAL'
              "
              (click)="openEditModal(entry)">

              ✎
            </button>

            <button
              class="icon-button danger"
              title="Excluir"
              [disabled]="
                entry.source !== 'MANUAL' ||
                deletingId === entry.id
              "
              (click)="deleteEntry(entry)">

              {{
                deletingId === entry.id
                  ? '...'
                  : '×'
              }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

  <div *ngIf="modalOpen" class="modal-backdrop" (click)="closeModal()">
    <section class="modal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <header class="modal-header">
        <div>
          <span class="eyebrow">{{ form.id ? 'EDITAR' : 'NOVO' }} LANÇAMENTO</span>
          <h2>{{ form.type === 'INCOME' ? 'Entrada' : 'Saída' }}</h2>
        </div>
        <button class="close-button" aria-label="Fechar" (click)="closeModal()">×</button>
      </header>

      <form class="modal-form" (ngSubmit)="saveEntry()">
        <div class="type-selector">
          <button type="button" [class.active-income]="form.type === 'INCOME'" (click)="form.type = 'INCOME'">↗ Entrada</button>
          <button type="button" [class.active-expense]="form.type === 'EXPENSE'" (click)="form.type = 'EXPENSE'">↘ Saída</button>
        </div>

        <div class="form-grid">
          <div class="field">
            <label for="entryDate">Data do lançamento</label>
            <input id="entryDate" type="date" name="entryDate" [(ngModel)]="form.entryDate" required>
          </div>
          <div class="field">
            <label for="amount">Valor</label>
            <input id="amount" type="number" name="amount" min="0.01" step="0.01" placeholder="0,00" [(ngModel)]="form.amount" required>
          </div>
          <div class="field full-width">
            <label for="category">Categoria</label>
            <input id="category" type="text" name="category" maxlength="80" placeholder="Ex.: Fornecedor, Energia, Venda" [(ngModel)]="form.category" required>
          </div>
          <div class="field full-width">
            <label for="description">Descrição</label>
            <textarea id="description" name="description" rows="4" maxlength="250" placeholder="Descreva o lançamento" [(ngModel)]="form.description" required></textarea>
          </div>
        </div>

        <footer class="modal-footer">
          <button type="button" class="button cancel-button" [disabled]="saving" (click)="closeModal()">Cancelar</button>
          <button type="submit" class="button primary" [disabled]="saving">
            {{ saving ? 'Salvando...' : 'Salvar lançamento' }}
          </button>
        </footer>
      </form>
    </section>
  </div>
</main>
